import cx from 'classnames'

import Styles from './CheckYourInboxForPasswordResetEmail.module.scss'
import Shared from '../../Shared.module.scss'
import { UserClient } from 'api/clients/UserClient'
import { SUPPORT_EMAIL } from 'utils/constants'
import RightPanelContent from '../RightPanelContent/RightPanelContent'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { GhostButton } from 'components/Buttons/GhostButton'
import { ReactComponent as LeftArrowIcon } from 'assets/icons/arrowLeft24.svg'

type Props = {
  email: string
  transitionPage: (page: string) => void
  workspaceInviteToken?: string
}

const CheckYourInboxForPasswordResetEmail = ({ email, transitionPage, workspaceInviteToken }: Props) => {
  const { isTabletPortrait } = useResponsiveDesign()
  const resendEmail = () => {
    UserClient.sendEmail(email, 'password_reset', undefined, workspaceInviteToken)
  }

  return (
    <div data-testid="checkYourInboxForPasswordResetEmail" className={cx(Shared.content, Shared.isBlaze)}>
      <div className={Shared.leftPanel}>
        <div className={Shared.header}>
          <GhostButton
            className={cx(Shared.backButton, Shared.isBlaze)}
            aria-label="Back"
            onClick={() => transitionPage('GO_BACK')}
          >
            <LeftArrowIcon />
          </GhostButton>
        </div>
        <div className={Shared.largerLeftContent}>
          <div className={cx(Shared.title, Shared.isBlaze)}>Password reset</div>
          <p className={Shared.subTitle}>We've emailed a link to reset your password, to:</p>
          <p className={Styles.emailText}>{email}</p>
        </div>
        <div className={Shared.footer}>
          <div>
            <p className={cx(Shared.linkWrapperText, Styles.linkWrapperText)}>
              Didn't get a reset email?{' '}
              <button className={Shared.link} type="button" onClick={resendEmail}>
                Send again
              </button>
            </p>

            <p className={cx(Shared.linkWrapperText, Styles.linkWrapperText)}>
              Still having trouble? Email{' '}
              <a className={Shared.link} href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
            </p>
          </div>
        </div>
      </div>
      {!isTabletPortrait && <RightPanelContent screen="checkYourInboxForPasswordResetEmail" />}
    </div>
  )
}

export default CheckYourInboxForPasswordResetEmail
